/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { FormElement } from "../FormElement";
import { IFormElementConfig } from "../IFormElementConfig";
import { FormModel } from "../FormModel";
import { FORM_EL_TYPE } from "../FormElementTypes";
import { IFormExpressionFn } from "../IFormExpressionFn";

/**
 * Element config
 */
export interface IFormHiddenExpressionConfig extends IFormElementConfig {
	value: IFormExpressionFn<FormHiddenExpression, any>;
}

/**
 * Field Hidden Expression
 */
export class FormHiddenExpression extends FormElement<IFormHiddenExpressionConfig> {

	private value: any;

	/**
	 * Element constructor
	 *
	 * @param model Model instance
	 * @param parent Parent element
	 * @param config Element configuration
	 */
	public constructor(
		model: FormModel,
		parent: FormElement<any>,
		config: IFormHiddenExpressionConfig
	) {

		super(model, parent, FORM_EL_TYPE.HIDDEN_EXPRESSION, config);

	}

	/**
	 * Updates the element
	 *
	 * @param resetState If to reset state
	 */
	public update(resetState: boolean = false) {

		this.model._addExpression(() => {

			this.value = this.config.value(this.model, this);
			this.emit("update");

		});

	}

	/**
	 * Returns element state
	 */
	public getState() {

		return {
			...super.getState(),
			value: this.value
		}

	}

}

/**
 * Declares hidden expression
 *
 * @param config Config
 */
export function HiddenExpression(
	config: IFormHiddenExpressionConfig
) {

	return (model, parent) => new FormHiddenExpression(model, parent, config);

}
